<p-panel styleClass="no-padding-panel panel-shadow">
  <p-header>
    <div class="panel-header">Supplier Information</div>
  </p-header>

  <div
    *ngIf="job == null || job?.supplier; else noSupplier"
    class="p-3"
    style="border-radius: 0 0 12px 12px"
  >
    <div [class.ghost]="loadingJob" class="supplier-info">
      <div class="flex-grow-1 ghost-values">
        <div class="label-value">
          <div class="label">Name:</div>
          <div class="value">
            <a href="app/supplier-information/{{ job?.supplier?.id }}" target="_blank">
              {{ job?.supplier?.name || '-' }}
            </a>
          </div>
        </div>
        <div class="label-value">
          <div class="label">Phone Number:</div>
          <div class="value">
            <a href="tel:{{ job?.supplier?.phoneNumber || '-' }}"
              >{{ job?.supplier?.phoneNumber || '' }}
            </a>
          </div>
        </div>
        <div class="label-value">
          <div class="label">Postcode:</div>
          <div class="value">{{ job?.supplier?.postcode || '-' }}</div>
        </div>
        <div class="label-value">
          <div class="label">Region:</div>
          <div class="value">{{ job?.region?.name || '-' }}</div>
        </div>
      </div>
      <div class="flex-grow-1 ghost-values">
        <!--
        <div class="label-value">
          <div class="label">Depot:</div>
          <div class="value">{{ job?.depot?.name }}</div>
        </div>
        -->
        <div class="label-value">
          <div class="label">Account Code:</div>
          <div class="value">{{ job?.accountCodeList?.code || '-' }}</div>
        </div>
        <div class="label-value">
          <div class="label">Supplier Tags:</div>
          <div class="value">
            <div *ngIf="job?.jobTags.length == 0">-</div>
            <div *ngIf="job?.jobTags">
              <span *ngFor="let tag of job?.jobTags; let i = index">
                {{ tag.description }}
                <span *ngIf="i < job?.jobTags?.length - 1">, </span>
              </span>
            </div>
          </div>
        </div>
        <div class="label-value">
          <div class="label">Purchase Channel:</div>
          <div class="value purchase-channel-value">
            <div class="channel-container">
              <div>{{ job?.purchaseChannel?.displayName || '-' }}</div>

              <div *ngIf="job?.secondaryPurchaseChannel" class="secondary-channel-row">
                <i class="las la-arrow-right" aria-hidden="true"></i>
                <div>{{ job?.secondaryPurchaseChannel?.displayName }}</div>
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  pTooltip="This value indicates that after the Job was first grabbed/assigned, it was extended with an additional route using the Extender function. The secondary purchase channel reflects how the extension was created."
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="label-value">
          <div class="label">Carryover Allowed:</div>
          <div class="value">{{ job?.supplier?.restrictCarryover ? 'No' : 'Yes' || '-' }}</div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noSupplier>
    <div
      class="no-supplier p-3"
      style="
        height: 150px;
        display: flex;
        align-items: center;
        background-color: #f9f9f9;
        border-radius: 0 0 12px 12px;
      "
    >
      <div class="text-center flex-grow-1">
        <div style="color: #999999; font-weight: 500">Awaiting Allocation</div>
        <div class="mt-2">
          <button
            pButton
            label="Job Deployment"
            class="ui-button-secondary"
            (click)="goToJobDeployment(job)"
          ></button>
          <div style="color: #999999; font-weight: 500" class="mt-2">Required Tags</div>
          <div *ngIf="job" class="mt-2 flex gap-2 justify-content-center">
            <span *ngFor="let tag of job.requiredTags" class="tag-item">
              {{ tag }}
            </span>
            <span *ngIf="job.requiredTags.length === 0">None</span>
          </div>
          <!--            <button-->
          <!--                    *ngIf="-->
          <!--      organisationTypeId == organisationTypeEnum.Engineius && previousAssignments(job).length > 0-->
          <!--    "-->
          <!--                    pButton-->
          <!--                    label="Previously assigned"-->
          <!--                    (click)="showPreviousSuppliers = !showPreviousSuppliers"-->
          <!--            ></button>-->
        </div>
      </div>
    </div>
  </ng-template>

  <p-footer class="no-rounded-top-border">
    <div class="text-right pt-2">
      <button
        pButton
        (click)="removeFromSupplier()"
        [disabled]="loadingJob || isJobCompleted(job)"
        label="Remove Supplier"
        class="ui-button-secondary btn-mobile-block mb-2"
        *ngIf="job?.supplier?.id"
      ></button>
      <button
        pButton
        label="Impersonate Supplier"
        (click)="impersonateSupplier()"
        class="ui-button-primary btn-mobile-block mb-2"
        [disabled]="loadingJob || isImpersonating"
        *ngIf="job?.supplier?.id"
      ></button>
      <!--        <button-->
      <!--                pButton-->
      <!--                class="mb-2"-->
      <!--                label="Previously assigned"-->
      <!--                (click)="showPreviousSuppliers = !showPreviousSuppliers"-->
      <!--                *ngIf="job?.supplier?.id"-->
      <!--        ></button>-->
      <ng-container *ngTemplateOutlet="previousSuppliers; context: { job: job }"></ng-container>
    </div>
  </p-footer>
</p-panel>

<p-dialog
  header="Impersonate Supplier"
  [(visible)]="showImpersonateSupplierDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>User</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="impersonateSupplierUsers"
          placeholder="Select user"
          appendTo="body"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedImpersonateUser"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="showImpersonateSupplierDialog = false"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Impersonate"
        class="ui-button ui-button-primary ml-2"
        (click)="impersonateSupplierConfirm()"
        [disabled]="!selectedImpersonateUser"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [(visible)]="showRemoveConfirm"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <p-header>Reason for Unassigning</p-header>

  <div class="p-2">
    <div class="ui-g">
      <div class="ui-g-3 text-right">Reason</div>
      <div class="ui-g-9">
        <p-dropdown
          appendTo="body"
          placeholder="Select a Reason"
          [options]="unassignReasons"
          [(ngModel)]="unassignReasonId"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-3 text-right">Comment</div>
      <div class="ui-g-9 pl-2">
        <textarea
          pInputTextarea
          [(ngModel)]="unassignComment"
          class="w-full"
          style="height: 100px"
        ></textarea>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-3">&nbsp;</div>

      <div class="ui-g-9 text-right">
        <button pButton class="" (click)="showRemoveConfirm = false" label="Cancel"></button>
        <button
          pButton
          class="ui-button-success"
          label="Confirm"
          (click)="confirmRemoveFromSupplier()"
          [disabled]="unassignReasonId == null"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>

<ng-template #previousSuppliers let-job="job">
  <span
    *ngIf="
      organisationTypeId == organisationTypeEnum.Engineius && previousAssignments(job)?.length > 0
    "
  >
    <div class="mt-2">
      <table class="table-striped unassigned-table">
        <thead>
          <tr>
            <th>Date Unassigned</th>
            <th>Supplier</th>
            <th>Unassigned Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let previous of previousAssignments(job)">
            <td>{{ previous?.jobUnassignedDate | datex : "ddd DD MMM 'YY HH:mm" }}</td>
            <td>{{ previous?.supplier.name }}</td>
            <td>{{ previous?.jobUnassignedReason.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </span>
</ng-template>
